import { useState, useEffect } from "react";

// Hook personnalisé pour surveiller localStorage
export const useLocalStorage = (key, initialValue = null) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Erreur lecture localStorage ${key}:`, error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      setStoredValue(value);
      window.localStorage.setItem(key, JSON.stringify(value));
      // Émettre un événement personnalisé pour notifier les autres composants
      window.dispatchEvent(new CustomEvent('localStorageChanged', {
        detail: { key, value }
      }));
    } catch (error) {
      console.error(`Erreur écriture localStorage ${key}:`, error);
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.detail && e.detail.key === key) {
        setStoredValue(e.detail.value);
      }
    };

    window.addEventListener('localStorageChanged', handleStorageChange);
    return () => window.removeEventListener('localStorageChanged', handleStorageChange);
  }, [key]);

  return [storedValue, setValue];
};

export default useLocalStorage;
